const InformativeCalculationView = () => import("@views/informative-calculation/informative-calculation-view.vue");
import InformativeCalculation from "@views/informative-calculation/informative-calculation.vue";

export const informativeCalculationRoutes = [
    {
        component: InformativeCalculationView,
        name: "informativeCalculationHome",
        path: "informative",
        redirect: { name: "informativeCalculation" },
        children: [
            {
                component: InformativeCalculation,
                name: "informativeCalculation",
                path: "calculation",
                meta: {
                    buttons: [
                        // { name: "CustomerContinue", action: "validatecustomer", visible: true },
                        { name: "Print", action: "printCalculation", visible: true },
                        { name: "Send", action: "sendCalculation", visible: true },
                    ]
                }
            }
        ]
    },
];